'use client';
import { NetworkEnum } from '@/config/config.types';
import { ActionType } from '@/utils/vault.utils';
import React from 'react';
import { AddressPurpose, AddressType } from 'sats-connect';

export enum WalletType {
  Xverse = 'xverse',
  Unisat = 'unisat',
}

export enum WalletTypeExtended {
  Xverse = 'xverse',
  Unisat = 'unisat',
  Leather = 'leather',
  Metamask = 'metamask',
  // MagicEden = 'magiceden',
}

export interface Address {
  address: string;
  publicKey: string;
  purpose: AddressPurpose;
  addressType: AddressType;
}

export interface Balance {
  confirmed: string;
  unconfirmed: string;
  total: string;
}

export interface WalletInfo {
  type: WalletType;
  address: string;
  network: NetworkEnum;
  publicKey?: string;
}

export interface WalletContextType {
  isConnected: boolean;
  walletInfo: WalletInfo | null;
  balance: Balance | null;
  // connect: (walletType: WalletType) => Promise<void>;
  disconnect: () => Promise<void>;
  isMainnet: boolean;
  toggleNetwork: () => void;
  activeWallet: WalletType | null;
  setActiveWallet: React.Dispatch<React.SetStateAction<WalletType | null>>;
  connectionError: boolean;
}

export interface TransactionHistoryItem {
  date: string;
  type: ActionType;
  amount: number;
  amountUnit: 'UNIT' | 'BTC';
  status: 'In Progress' | 'Completed';
  healthFactorBefore: number | null;
  healthFactorAfter?: number | null;
  healthStatusBefore: {
    statusColor: string;
    rangeColor: string;
    status: string;
  };
  healthStatusAfter?: {
    statusColor: string;
    rangeColor: string;
    status: string;
  };
  transactionId: string;
  btcInVault?: number;
  unitInVault?: number;
  vault_txid?: string;
  isFullRepay?: boolean;
}
